import { render } from "./VersionChatbotView.vue?vue&type=template&id=64589eac"
import script from "./VersionChatbotView.vue?vue&type=script&lang=js"
export * from "./VersionChatbotView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__